<template>
  <div class="row">
    <div class="offset-md-3 col-lg-6 col-md-12" style="border: 1px solid black;">
      <div class="cabinet-login-form">
        <h3 class="d-none d-sm-block">Анкетирование потребителей услуг</h3>
        <a href="/anketa" class="btn btn-success">
          <i class="fas fa-smile"></i> Пройти анкетирование
        </a>
        <br />
        <br />
      </div>
    </div>
    <div class="col-md-6" style="1background-color: #f8f9fa!important;">
      <newsblock :news="jsonNews.edu"></newsblock>
    </div>
    <div class="col-md-6" style="1background-color: #f8f9fa!important;">
      <newsblock :news="jsonNews.culture"></newsblock>
    </div>
  </div>
</template>

<script>
//import json from "../../../assets/News.json";
import newsblock from "./blocks/block.vue";
import axios from 'axios';

export default {
  created: function() {
    axios.get('http://eduqa.egechita.ru/back/news').then((Response) => {
      this.jsonNews = Response.data;
    });
  },
  components: { newsblock },
  data() {
    return {
      jsonNews: ""
    };
  }
};
</script>

<style>
</style>
